import {observer} from 'mobx-react-lite';

import TextField from '@material-ui/core/TextField';

import CustomerQuoteFormStore from '../FormStore';

const CustomerFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getCustomerErrors();
    const values = state.getCustomer();
    return (
        <>
            <TextField
                autoFocus
                required
                defaultValue={values.firstName}
                margin="normal"
                label="First Name"
                error={!!errors.firstName}
                helperText={errors?.firstName}
                onChange={(e) => {
                    state.setCustomer('firstName', e.target.value);
                }}
                fullWidth
            />
            <TextField
                margin="normal"
                required
                defaultValue={values.lastName}
                label="Last Name"
                error={!!errors.lastName}
                helperText={errors?.lastName}
                onChange={(e) => {
                    state.setCustomer('lastName', e.target.value);
                }}
                fullWidth
            />
            <TextField
                required
                defaultValue={values.email}
                margin="normal"
                label="Email Address"
                type="email"
                error={!!errors.email}
                helperText={errors?.email}
                onChange={(e) => {
                    state.setCustomer('email', e.target.value);
                }}
                fullWidth
            />
            <TextField
                required
                defaultValue={values.phoneNumber}
                margin="normal"
                label="Phone"
                type="phone"
                error={!!errors.phoneNumber}
                helperText={errors?.phoneNumber}
                onChange={(e) => {
                    state.setCustomer('phoneNumber', e.target.value);
                }}
                fullWidth
            />
        </>
    );
});

export default CustomerFields;
